(() => {
 'use strict';
 if (customElements.get('material-comparison')) return;
 // Rows settle and rating segments draw in the first time the comparison becomes visible (page scroll or drawer opening).
 customElements.define('material-comparison', class extends HTMLElement {
  connectedCallback() {
   if (this.observer || !('IntersectionObserver' in window)) return;
   if (matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;
   const rect = this.getBoundingClientRect();
   if (rect.height && rect.top < innerHeight * .85 && rect.bottom > 0) return;
   this.setAttribute('data-pending', '');
   this.observer = new IntersectionObserver(entries => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    this.observer.disconnect();
    requestAnimationFrame(() => this.removeAttribute('data-pending'));
   }, {threshold: .12});
   this.observer.observe(this);
  }
  disconnectedCallback() {
   this.observer?.disconnect();
   this.observer = null;
   this.removeAttribute('data-pending');
  }
 });
})();
